import Vue from 'vue'

import Api from '../api/Api'
import { redirectToLogin } from '../api/peer/user'

let sessionMonitor = (r) => {
    let url = r.config.url.split('/')
    let model = url[5]
    let method = url[6]
    
    if(
        model === 'authenticate'
            ||
        (model === 'Member' && method === 'getInfo')
    ) {
        return false
    }
    
    if(
        r.data
            &&
        r.data.errorCode
            &&
        r.data.errorCode === 'API_TOKEN_EXPIRED'
    ) {
        redirectToLogin()
    }
}

let apiCallback = (r) => {
    sessionMonitor(r)
}

Vue.use(Api, {
    callerId: 'fd632103d495686ce6322befbd2741f9',
    onResponseSuccessCallback: apiCallback,
    onResponseErrorCallback: apiCallback
})

import peer from '../api/peer'
Vue.use(peer)

import Bus from '../api/Bus'
Vue.use(Bus)

window.jQuery = Vue.peer.$ = require('jquery')
Vue.peer._ = require('lodash')
require('jquery-backstretch')

import AppComponents from './_app-components'
Vue.use(AppComponents)

import AppDirectives from './_app-directives'
Vue.use(AppDirectives)

import '../../node_modules/slick-carousel/slick/slick.css'

import '../assets/main.css'
